import { z } from "zod";

/** CUID (Prisma default ID) — 25 chars. */
export const cuidSchema = z.string().regex(/^c[a-z0-9]{24}$/, "ID invalido");

/** Slug URL-safe (lowercase, hifens, 2-60 chars). */
export const slugSchema = z
  .string()
  .min(2)
  .max(60)
  .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, "Slug invalido");
